<template>
  <div>
    <div></div>
    <div class="container" id="dad">
      <div v-show="active == '1'" class="div-three" id="son">
        <div class="content">
          <h2 class="center-title">古今融合传真理・为人民守健康</h2>
          <div class="info">
            三元融合医疗深耕传统中医药现代化赛道，以《黄帝内经》五运六气为核心理论根基，独创天・地・人</strong>三元合一诊疗体系，融合千年中医智慧与大数据、人工智能前沿科技，打造可量化、标准化、可复制的现代化中医医疗解决方案，是集诊疗落地、药房运营、名医培育、疑难攻坚、全民健康管理于一体的综合性大健康赋能平台。
          </div>
        </div>

        <div class="content">
          <h2 class="center-title">三元医学核心逻辑：天时为经，地利为纬，人和为本</h2>
          <ul class="info-list">
            <li>天・时间运气学：数字化推演五运六气，预判时令疾病流行趋势，落地治未病前瞻性健康管理；</li>
            <li>地・空间环境学：结合地域水土、气候特征构建区域体质图谱，定制因地制宜的调理与用药方案；</li>
            <li>人・个体体质学：精准辨识先天禀赋与后天体质，三因制宜搭配现代药理，实现个性化精准施治。</li>
          </ul>
        </div>

        <div class="content">
          <div class="info">
            依托自研智能化诊疗辅助系统与智慧药房闭环体系，我们破解传统中医疗效不稳定、落地无标准、盈利难持依托自研智能化诊疗辅助系统与智慧药房闭环体系，我们破解传统中医疗效不稳定、落地无标准、盈利难持续、疑难病症难攻克四大行业痛点，构建三元疗法
            + 智慧药房 + 疑难攻坚 + 名医培育 + 健康守护五位一体全链路业务生态。
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "1",
      content: [
        "业务合作：高总 17313168155",
        "终端合作：邓总 18180307265",
        "学术合作：张总 15608171513",
        "公司地址：四川关盈堂科技有限公司",
        "关盈堂诚邀天下英才合作共赢！",
      ],
    };
  },
  methods: {
    navSelect(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped>
.container {
  width: 980px;
  min-height: 520px;
  margin: auto auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 30px auto;
  /*background: #156098;*/
  /* background-image: url("/static/image/partner.png"); */
  background-size: 100% 100%;
  overflow: auto;
}

.left-title {
  font-size: 22px;
  font-weight: 700;
  color: #304744;
  margin: 0 0 18px 0;
  letter-spacing: 1px;
}

.content {
  margin-left: 30px;
  font-size: 20px;
  line-height: 50px;
  text-align: left;
}

.title {
  display: inline-block;
  width: 120px;
}

.info {
  flex: 1;
  text-indent: 2em;
}

.div-three {}

#dad {
  padding: 0 120px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.el-menu-vertical {
  background-color: transparent !important;
}

/* 信息内容样式 */
.info strong {
  color: #156098;
  font-weight: 700;
}

/* 居中标题 */
.center-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #304744;
  margin: 0 0 18px 0;
  letter-spacing: 1px;
}

.center-title strong {
  color: #156098;
  font-weight: 700;
}

.info-subtitle {
  font-weight: 700;
  color: #304744;
  margin: 0 0 14px 0;
  font-size: 18px;
}

.info-list {
  margin: 0;
  padding-left: 22px;
  list-style: none;
}

.info-list li {
  position: relative;
  line-height: 2;
  margin-bottom: 6px;
  padding-left: 4px;
}

.info-list li::before {
  content: "•";
  position: absolute;
  left: -16px;
  top: 0;
  color: #156098;
  font-weight: 700;
  font-size: 18px;
  line-height: 2;
}

.info-list li strong {
  color: #156098;
  font-weight: 700;
}
</style>
